import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Subject} from 'rxjs';
import {objectLiteralExpression} from 'codelyzer/util/astQuery';
import { tap } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';

const API_URL = environment.apiUrl;


@Injectable({providedIn: 'root'})
export class ReunionesService {


  constructor(private http: HttpClient,
    private customAlertService: CustomAlertService) {
  }

  private _meeting;

  private subject = new Subject<any>();

  get meeting() {
    return this._meeting;
  }

  set meeting(value) {
    this._meeting = value;
  }

  updateAssetParent(dataset, tipoParent, parentId, collection) {
    const obj = collection.find(objF => {
      return objF.id === +dataset.objId;
    });
    obj.tipoParent = tipoParent;
    obj.tipoParentId = tipoParent;
    obj.parentId = +parentId;
    this.saveMeetingAsset(obj, '/api/reuniones/asset').subscribe(res => {
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No se ha podido actualizar el recurso. ${err.error} <br> Código de error: ${err.statusText}`
      });
    });
  }

  updateListOrder(coleccion, idOrigen = 0) {
    const accion = idOrigen === 0 ? 'asset' : 'objetivo',
      idsList = [];
    coleccion.map(element => {
      idsList.push(element.id);
    });
    this.http.put(`${API_URL}/api/reuniones/${accion}/ordenar`, {idOrigen: idOrigen, ids: idsList.toString()}).subscribe(res => {
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No se ha podido reordenar las metas. ${err.error} <br> Código de error: ${err.statusText}`
      });
    });
  }

  getMeetingsList() {
    return this.http.get(`${API_URL}/api/reuniones`);
  }

  getMeeting(id) {
    return this.http.get(`${API_URL}/api/reuniones/${id}`);
  }

  createMeeting() {
    return this.http.post(`${API_URL}/api/reuniones`, {});
  }

  updateMeetingConfig(model) {
    return this.http.put(`${API_URL}/api/reuniones`, model);
  }

  updateMeetingSession(session) {
    const action = session.id === 0 ? 'post' : 'put';
    return this.http[action](`${API_URL}/api/reuniones/sesion`, session);
  }

  closeMeeting(model) {
    return this.http.put(`${API_URL}/api/reuniones/terminar`, model);
  }

  saveMeetingAsset(object, url) {
    const action = object.id === 0 ? 'post' : 'put';
    return this.http[action](`${API_URL}${url}`, object);
  }

  getAsset(id) {
    return this.http.get(`${API_URL}/api/Reuniones/asset/${id}`);
  }

  getObjective(id, reunionID) {
    return this.http.get(`${API_URL}/api/Reuniones/${reunionID}/objetivo/${id}`);
  }

  deleteMeetingAsset(object, tipo) {
    return this.http.post(`${API_URL}/api/reuniones/${tipo}/borrar`, object);
  }

  deleteMeetingResource(resourceID) {
    return this.http.delete(`${API_URL}/api/recursos/borrar/${resourceID}`);
  }

  getAssitants(str) {
    return this.http.get(`${API_URL}/api/Personas/buscar/${str}`);
  }

  addParticipants(collection, url) {
    return this.http.post(`${API_URL}${url}`, collection);
  }

  updateParticipant(participant) {
    return this.http.put(`${API_URL}/api/Reuniones/participante`, participant);
  }

  deleteParticipants(collection) {
    return this.http.post(`${API_URL}/api/Reuniones/participantes/borrar`, collection);
  }

  updateParticipantPresentStatus(assistant) {
    return this.http.put(`${API_URL}/api/Reuniones/participante/presente`, assistant);
  }

  getMeetingOwners() {
    return this.http.get(`${API_URL}/api/personas/colaboradores`);
  }

  setMeetingTag(tag, url) {
    return this.http.post(`${API_URL}${url}`, tag);
  }

  notificar(obj) {
    return this.http.post(`${API_URL}/api/reuniones/notificar`, obj);
  }

  notificarTarea(obj) {
    return this.http.post(`${API_URL}/api/reuniones/tareas/notificar`, obj);
  }

  cancelMeeting(id) {
    return this.http.put(`${API_URL}/api/reuniones/borrar`, id);
  }

  searchMeetings(obj) {
    return this.http.post(`${API_URL}/api/reuniones/buscar`, obj);
  }

  setMeetingTitle(title) {
    this.subject.next({event: 'meeting-title', title});
  }

  setMeetingName(name) {
    this.subject.next({event: 'meeting-name', name});
  }

  setMeetingDate(date) {
    this.subject.next({event: 'meeting-date', date});
  }

  setMeetingTime(time) {
    this.subject.next({event: 'meeting-time', time});
  }

  setMeetingDuration(duration) {
    this.subject.next({event: 'meeting-duration', duration});
  }

  setMeetingBasicData(meetingData) {
    this.subject.next({event: 'meeting-basic-data', meetingData});
  }

  updateTimer() {
    this.subject.next({event: 'update-timer'});
  }

  openSearch() {
    this.subject.next({event: 'open-search'});
  }

  closeSearch() {
    this.subject.next({event: 'close-search'});
  }

  toggleFilters(state) {
    this.subject.next({event: 'toggle-filters', state});
  }

  getObservable() {
    return this.subject.asObservable();
  }

  public extractData(res: any) {
    const body = res.hasOwnProperty('items') ? res.items : res;
    return body || {};
  }
}
